import axios from 'axios';

export default {
  getList(_, params) {
    return axios.get('User/GetList', { params });
  },
  delete(_, id) {
    return axios.get('User/Delete', { params: { id } });
  },
  reset(_, id) {
    return axios.post('User/Reset?id='+id);
  },
  save(_, params){
    return axios.post('User/Add', params);
  },
  changePassword(_, { password, oobCode }) {
    return axios.post('User/ChangePassword', { password, oobCode });
  }
};
